module.exports = __webpack_public_path__ + "static/CircularStd-MediumItalic-e80d8785c7112d3823e69e7e4421a083.ttf";